export default __webpack_public_path__ + "static/media/7.11b1a670.jpg";